import AccordionHtml from './rfct/html/accordion-html';
import LinkListHtml from './rfct/html/link-list-html';
import moduleRegistry from './rfct/module-registry/module-registry';

// eslint-disable-next-line no-undef

let $globalConfig;
if (document.querySelectorAll('.catalog').length > 0 || document.querySelectorAll('.eifu').length > 0) {
    // eslint-disable-next-line no-undef
    $globalConfig = config;
}

const categoryConfig = {
    selectors: {
        resultList: '.catalog__cards-aoe-overview',
    },
};

function init() {
    $(categoryConfig.selectors.resultList).each((i, el) => {
        const $searchResultList = $(el);
        initAoeOverview($searchResultList);
    });
}

function initAoeOverview($searchResultList) {
    const $divisionID = $searchResultList.attr('data-id');
    const apiURL = `${$globalConfig.urls.getRecursiveCategoriesAOE}?category=${$divisionID}`;
    jQuery.ajax({
        type: 'GET',
        url: apiURL,
        processData: false,
        dataType: 'json',
        success(data) {
            let html = '';

            if (data.specialtyCategories && data.specialtyCategories.length > 0) {
                const categorieAccordion = createAccordion(data.specialtyCategories, $searchResultList, '#target');
                const targetContainer = '<div id="target" class="rfct-horizontal-accordion-target"></div>';

                html += `
                <div class="col-xs-12">
                    <div class="rfct-textblock">
                        <h2 class="mb-3">${$globalConfig.textResources.productCatalogConnectorConfig.labelForSpecificSpecialties}</h2>
                    </div>
                    <div class="row">
                        <div class="col-lg-4">
                            ${categorieAccordion}
                        </div>
                        <div class="col-lg-5 offset-lg-1">
                            ${targetContainer}
                        </div>
                    </div>
                </div>`;
            }

            if (data.crossDisciplinaryCategories && data.crossDisciplinaryCategories.length > 0) {
                const crossDisciplinaryCategoriesAccordion = createAccordion(data.crossDisciplinaryCategories, $searchResultList, '#target2');
                const targetContainer2 = '<div id="target2" class="rfct-horizontal-accordion-target"></div>';

                html += `<div class="col-xs-12">
                <div class="rfct-textblock rfct-textblock__margin">
                    <h2 class="mb-3">${$globalConfig.textResources.productCatalogConnectorConfig.labelForCrossDisciplinarySpecialties}</h2>
                </div>
                <div class="row">
                    <div class="col-lg-4">
                        ${crossDisciplinaryCategoriesAccordion}
                    </div>
                    <div class="col-lg-5 offset-lg-1">
                        ${targetContainer2}
                    </div>
                </div>
            </div>`;
            }

            if (data.vetCategories && data.vetCategories.length > 0) {
                const vetCategoriesAccordion = createAccordion(data.vetCategories, $searchResultList, '#target3');
                const targetContainer3 = '<div id="target3" class="rfct-horizontal-accordion-target"></div>';

                html += `<div class="col-xs-12">
                <div class="rfct-textblock rfct-textblock__margin">
                    <h2 class="mb-3">${$globalConfig.textResources.productCatalogConnectorConfig.labelForVetSpecificSpecialties}</h2>
                </div>
                <div class="row">
                    <div class="col-lg-4">
                        ${vetCategoriesAccordion}
                    </div>
                    <div class="col-lg-5 offset-lg-1">
                        ${targetContainer3}
                    </div>
                </div>
            </div>`;
            }

            if (html !== '') {
                moduleRegistry.insertHTML($searchResultList, html);
                // eslint-disable-next-line no-undef
                const myLazyLoad = new LazyLoad();
                myLazyLoad.update();
                // eslint-disable-next-line no-undef
                picturefill();
            }
        },
        error() {
            // eslint-disable-next-line no-console
            // console.log('Error loading aoe overview result!');
        },
    });
}

function createAccordion(categories, $searchResultList, target) {
    const accordionItems = [];

    categories.forEach((category) => {
        const categoryURL = category.hasChildren ? `${$globalConfig.urls.areaOfExpertiseHtml}?cat=${category.identifier}`
            : `${$globalConfig.urls.searchHtml}?cat=${category.identifier}`;

        let contentHtml = `
            <a href="${categoryURL}">
                <button class="rfct-button rfct-button--secondary rfct-button--small">
                    <span class="rfct-button__inner">
                        <span class="rfct-button__label">${$globalConfig.textResources.productCatalogConnectorConfig.categoryPageLinkText}</span>
                        <span class="rfct-button__icon material-icons">
                            chevron_right
                        </span>
                    </span>
                </button>
            </a>
            <div class="rfct-textblock">
                <h2 class="mt-5 mb-4">${category.name}</h2>
            </div>
        `;

        category.children.forEach((child) => {
            const childs = [];

            child.children.forEach((subChild) => {
                // eslint-disable-next-line max-len
                const baseUrl = subChild.hasChildren ? $globalConfig.urls.categoryHtml : $globalConfig.urls.searchHtml;

                const categoryChildChildURL = `${baseUrl}?cat=${subChild.identifier}`;

                childs.push({ title: subChild.name, link: categoryChildChildURL });
            });

            const subline = child.children.length ? `<div class="rfct-textblock mb-3"><span class="rfct-textblock__subline">${child.name}</span></div>` : '';
            contentHtml += `${subline}<div class="mb-5">${new LinkListHtml(childs)}</div>`;
        });

        accordionItems.push({ title: category.name, content: contentHtml });
    });

    const multiple = false;
    return new AccordionHtml(accordionItems, multiple, target).toString();
}

if (document.querySelectorAll('.catalog').length > 0 || document.querySelectorAll('.eifu').length > 0) {
    init();
}
